import React, { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { json, Link } from 'react-router-dom'
import { subscribe } from "../utils/pubsub"
import Modal from '../ui-elements/Modal'
import Spinner from '../ui-elements/Spinner'
import Radio from '../formfields/Radio'
import Checkbox from '../formfields/Checkbox'
import Number from '../formfields/Number'
import Button from '../formfields/Button'
import Card from '../ui-elements/Card'
import { table } from 'console'
import Dropdown from '../formfields/Dropdown'
import RedAlert from '../ui-elements/RedAlert'




type Props = {
}

type StickerPackCardProps = {
  stickerPack: ObjectStringKeyAnyValue
  setAddOrEditItem: React.Dispatch<React.SetStateAction<any>>
}

type AddOrEditProps = {
  addOrEditItem: string | null
  setAddOrEditItem: React.Dispatch<React.SetStateAction<any>>
  setSavingProgress: React.Dispatch<React.SetStateAction<any>>
  paymentPlansFromStripe: ObjectStringKeyAnyValue | null
}


function StickerPackCard({
  stickerPack,
  setAddOrEditItem
}: StickerPackCardProps) {

  const {
    tableData,
    userData,
    fridges,
    currentOrganisation,
    switchCurrentOrganisation,
    sendMessageToWebsocket
  } = useContext(GlobalContext)


  const stickersForThisPack = stickerPack.Id && tableData.StickerPackIds && tableData.StickerPackIds[stickerPack.Id] && tableData.StickerPackIds[stickerPack.Id].Stickers

  return <div
    className={`rounded bg-white border border-gray-300 hover:opacity-80 px-3 py-2 cursor-pointer`}
    onClick={() => { setAddOrEditItem(stickerPack.Id) }}
  >

    <p className={`font-bold text-sm`}>#{stickerPack.Id}</p>
    {stickerPack.OrganisationId && <p className={`text-xs`}>Assigned to:<br />


      {tableData && tableData.OrganisationNamesList && tableData.OrganisationNamesList[stickerPack.OrganisationId] ?
        ` ${tableData.OrganisationNamesList[stickerPack.OrganisationId]}`
        : `Org #${stickerPack.OrganisationId}`
      }


    </p>}
    {/* {stickerPack.PaymentPlan && <p>{stickerPack.PaymentPlan}</p>} */}
    {/* {stickerPack.RequirePaymentMethod
      && <p>Require payment method? {stickerPack.RequirePaymentMethod ? 'Yes' : 'No'}</p>} */}

    {tableData.AssetTypes && Object.keys(tableData.AssetTypes).length > 0 && <div className={`flex flex-col`}>
      {Object.keys(tableData.AssetTypes).map((assetTypeId, index) => {
        const assetTypeName = tableData.AssetTypes[assetTypeId].DisplayName
        const stickersForThisAsset = stickersForThisPack ? Object.values(stickersForThisPack).filter((sticker: any) => sticker.AssetTypeId === assetTypeId).length : 0
        if (stickersForThisAsset > 0) {
          return <p key={index} className={`text-xs`}>
            {stickersForThisAsset} x {assetTypeName ? assetTypeName : `asset type #${assetTypeId}`}
          </p>
        }
      })}
    </div>}
  </div>
}



function AddOrEdit({
  addOrEditItem,
  setAddOrEditItem,
  setSavingProgress,
  paymentPlansFromStripe
}: AddOrEditProps) {

  const {
    tableData,
    userData,
    fridges,
    currentOrganisation,
    switchCurrentOrganisation,
    sendMessageToWebsocket
  } = useContext(GlobalContext)


  const maxNumberOfAssets = 20
  const [formFields, setFormFields] = useState<ObjectStringKeyAnyValue>({})

  const stickersForThisPack = addOrEditItem && tableData.StickerPackIds && tableData.StickerPackIds[addOrEditItem] && tableData.StickerPackIds[addOrEditItem].Stickers


  const handleChange = (key: string, value: any) => {
    const newFieldValues: ObjectStringKeyAnyValue = { ...formFields }
    if (value) {
      if (newFieldValues[key]) {
        newFieldValues[key]['value'] = value
      } else {
        newFieldValues[key] = { 'value': value }
      }
    } else {
      delete newFieldValues[key]
    }
    setFormFields(newFieldValues)
  }


  const validateForm = () => {
    let formIsValid = true
    const newFieldValues: ObjectStringKeyAnyValue = { ...formFields }
    for (const key in formFields) {
      if (parseInt(`${formFields[key]['value']}`) < 0 || parseInt(`${formFields[key]['value']}`) > maxNumberOfAssets) {
        console.log('invalid')
        formIsValid = false
        newFieldValues[key]['isValid'] = false
      } else {
        delete newFieldValues[key]['isValid']
      }
    }
    if (Object.keys(formFields).length === 0) {
      formIsValid = false
      newFieldValues['general'] = `Please add assets from at least one type`
    } else {
      delete newFieldValues['general']
    }

    setFormFields(newFieldValues)
    return formIsValid
  }

  const saveData = () => {
    const isValid = validateForm()
    if (isValid && addOrEditItem === 'addNew') {
      makeStickerPack()
    }
  }

  const makeStickerPack = async () => {
    setAddOrEditItem(null)
    setSavingProgress(true)
    const payload = JSON.stringify({
      action: "superAdmin",
      subaction: "makeStickerPack",
      formFields: formFields
    })
    const unsubscribe = subscribe("makeStickerPackResponse", data => {
      setSavingProgress(false)
      window.location.href = data.downloadUrl
      fetchMultiTableData()
      unsubscribe()
    })
    sendMessageToWebsocket(payload)
  }


  const fetchMultiTableData = () => {
    let requestAssets = JSON.stringify({
      action: "fetchMultiTableData",
      tablesToFetch: ['Assets', 'AssetTypes', 'Groups', 'Checklists', 'ChecklistQuestions', 'Users'],
    })
    sendMessageToWebsocket(requestAssets)
  }


  return <Modal showCloseButton={true} setShowModal={setAddOrEditItem} closeButtonValue={null}>
    <div className={`flex flex-col gap-4`}>
      <h3 className={`w-full text-xl font-bold text-brandblue `}>
        {addOrEditItem === 'addNew' ? 'Build a new sticker pack' : `Sticker pack: #${addOrEditItem}`}
      </h3>



      {addOrEditItem &&
        tableData &&
        tableData.StickerPackIds &&
        tableData.StickerPackIds[addOrEditItem] &&
        tableData.StickerPackIds[addOrEditItem].OrganisationId &&
        <p>Assigned to:

          {tableData.OrganisationNamesList &&
            tableData.OrganisationNamesList[tableData.StickerPackIds[addOrEditItem].OrganisationId] ?
            ` ${tableData.OrganisationNamesList[tableData.StickerPackIds[addOrEditItem].OrganisationId]} (${tableData.StickerPackIds[addOrEditItem].OrganisationId})` :
            ` Org id #${tableData.StickerPackIds[addOrEditItem].OrganisationId}`
          }

        </p>}




      {addOrEditItem === 'addNew' && tableData.AssetTypes && Object.keys(tableData.AssetTypes).length > 0 && <div className={`flex flex-col gap-4`}>
        {Object.keys(tableData.AssetTypes).map((assetTypeId, index) => {
          const assetTypeName = tableData.AssetTypes[assetTypeId].DisplayName
          const stickersForThisAsset = stickersForThisPack ? Object.values(stickersForThisPack).filter((sticker: any) => sticker.AssetTypeId === assetTypeId) : null
          return <div key={index} className={`flex flex-col gap-2`}>
            <p className={``}>Number of asset type "{assetTypeName}":</p>
            <Number
              formFields={formFields}
              labelText={``}
              handleChange={handleChange}
              fieldName={`${assetTypeId}`}
              errorMessage={`Please enter a number between 0 and ${maxNumberOfAssets}`}
              min={1}
              max={maxNumberOfAssets}
            />
          </div>
        })}
      </div>}

      {addOrEditItem !== 'addNew' && tableData.AssetTypes && Object.keys(tableData.AssetTypes).length > 0 && <div className={`flex flex-col gap-4`}>
        {Object.keys(tableData.AssetTypes).map((assetTypeId, index) => {
          const assetTypeName = tableData.AssetTypes[assetTypeId].DisplayName
          const stickersForThisAsset = stickersForThisPack ? Object.values(stickersForThisPack).filter((sticker: any) => sticker.AssetTypeId === assetTypeId).length : 0
          if (stickersForThisAsset > 0) {
            return <div key={index} className={`flex flex-col gap-2`}>
              {stickersForThisAsset} x {assetTypeName ? assetTypeName : `asset type #${assetTypeId}`}
            </div>
          }
        })}
      </div>}

      {(!tableData.AssetTypes || Object.keys(tableData.AssetTypes).length === 0) && <RedAlert>No asset types have been set up</RedAlert>}


      {/* <p className={`text-xs`}>{JSON.stringify(formFields).replaceAll(',', ', ')}</p> */}


      {formFields['general'] && <RedAlert size={'small'}>{formFields['general']}</RedAlert>}
      <div className={`flex flex-row gap-4`}>

        <Button
          onClick={() => setAddOrEditItem(null)}
          text={'Close'}
          variant={'gray'}
          fullwidth={true}
          size={'big'}
        />

        {addOrEditItem === 'addNew' && tableData.AssetTypes && Object.keys(tableData.AssetTypes).length > 0 && <Button
          onClick={saveData}
          text={'Save'}
          variant={'primary'}
          fullwidth={true}
          size={'big'}
        />
        }
      </div>



    </div>
  </Modal>
}



function StickerPacks({

}: Props) {

  const {
    tableData,
    sendMessageToWebsocket,
  } = useContext(GlobalContext)


  const [addOrEditItem, setAddOrEditItem] = useState<string | null>(null)
  const [paymentPlansFromStripe, setPaymentPlansFromStripe] = useState<ObjectStringKeyAnyValue | null>(null)
  const [savingProgress, setSavingProgress] = useState(false)

  useEffect(() => {
    if (tableData && tableData.Prices) {
      setPaymentPlansFromStripe(tableData.Prices)
    }
   
  }, [tableData])


  // const fetchPaymentPlans = async () => {
  //   const payload = JSON.stringify({
  //     action: "superAdmin",
  //     subaction: "requestStripePlans"
  //   })
  //   sendMessageToWebsocket(payload)
  // }

  const fetchOrganisationList = async () => {
    const payload = JSON.stringify({
      action: "superAdmin",
      subaction: "fetchOrganisationList"
    })
    sendMessageToWebsocket(payload)
  }


  return <div className={`flex flex-col items-center`}>
    <div className={`max-w-3xl w-full p-5 flex flex-col gap-5 items-start`}>


      <div className={`w-full flex flex-row items-center justify-between gap-4`}>
        <h2 className={`text-4xl font-bold text-brandblue `}>Sticker Packs</h2>
        <Button
          onClick={() => setAddOrEditItem('addNew')}
          text={'Build a new pack'}
          fullwidth={false}
        />
      </div>

      {tableData && tableData.StickerPackIds ? <div className={`flex flex-col gap-3 items-start`}>
        <p>Assigned:</p>
        <div className={`flex flex-wrap flex-row gap-2`}>
          {Object.keys(tableData.StickerPackIds).map((stickerPackId, index) => {
            if (tableData.StickerPackIds[stickerPackId].OrganisationId) {
              return <StickerPackCard
                key={index}
                setAddOrEditItem={setAddOrEditItem}
                stickerPack={tableData.StickerPackIds[stickerPackId]}
              />
            }
          })}
        </div>

        <p>Unassigned:</p>
        <div className={`flex flex-wrap flex-row gap-2`}>
          {Object.keys(tableData.StickerPackIds).map((stickerPackId, index) => {
            if (!tableData.StickerPackIds[stickerPackId].OrganisationId) {
              return <StickerPackCard
                key={index}
                setAddOrEditItem={setAddOrEditItem}
                stickerPack={tableData.StickerPackIds[stickerPackId]}
              />
            }
          })}
        </div>
      </div>
        :
        <Spinner><p>Loading...</p></Spinner>
      }

    </div>

    {addOrEditItem && <AddOrEdit
      addOrEditItem={addOrEditItem}
      setAddOrEditItem={setAddOrEditItem}
      setSavingProgress={setSavingProgress}
      paymentPlansFromStripe={paymentPlansFromStripe}
    />}

    {savingProgress && <Modal
      showCloseButton={true}
      setShowModal={setSavingProgress}
    ><Spinner><p>Updating...</p></Spinner>
    </Modal>}

  </div>

}

export default StickerPacks